import AppContainer from 'stories/layouts/AppContainer'
import SidebarNavigation from './navigation/SidebarNavigation'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducer'

interface Props {
    primarySectionTitle: string
    secondarySectionTitle: string
    primaryComponent: JSX.Element
    secondaryComponent: JSX.Element
    children?: JSX.Element
    showSearch?: boolean
    headerTitle?: string | JSX.Element
    showBackButton?: boolean
    hideSecondarySection?: boolean
    headerComponent?: JSX.Element
}

const AppWrapper = (props: Props) => {
    const router = useRouter()
    const authenticatedUser = useSelector((state: AppState) => state.user)

    useEffect(() => {
        if (!router.isReady) return

        if (!authenticatedUser) {
            router.push(`/auth/signin?redirect=${router.asPath}`)
        }
    }, [authenticatedUser, router])

    return <AppContainer navigationComponent={<SidebarNavigation />} {...props}></AppContainer>
}

export default AppWrapper
